import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/MisionVision.scss";

const MisionVision = () => {
  return (
    <section className="misionVisionContainer" id="misionVision">
      <Fade>
        <p className="subtitleMisionVision">
          En Asesorarte en Seguros trabajamos cada día para transformar vidas a través de la protección, la educación financiera y la abundancia.
        </p>
      </Fade>

      <div className="cardsMVContainer">
        <Fade direction="left" duration={1000}>
          <div className="cardMV">
            <h5 className="tituloMV">VISIÓN</h5>
            <p className="textoMV">
              Ser la principal promotoria que impulse a cientos de agentes de seguros comprometidos con la protección y el bienestar de más de <b>10,000 familias</b>, promoviendo una carrera enriquecedora, estable y rentable.
            </p>
          </div>
        </Fade>

        <Fade direction="right" duration={1000}>
          <div className="cardMV">
            <h5 className="tituloMV">MISIÓN</h5>
            <p className="textoMV">
              Ayudar a cientos de personas a encontrar la abundancia en su vida, asesorando a miles de familias en temas financieros y de protección, para construir un presente y un futuro lleno de seguridad y prosperidad para nuestros clientes.
            </p>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default MisionVision;
